import React from "react";
import { Box, Typography } from "@mui/material";
import MobileCards from "./MobileCards";
import { useSelector } from "react-redux";
import image3 from "../../assets/agrohub.jpg";
import image1 from "../../assets/fritolay.jpg";
import image2 from "../../assets/gsat.jpg";

export default function MobileContainer() {
  const cardData = [
    {
      image: image1,
      title: "Fritolay Agriculture",
      appName: "FLAG",
      appUrl: `${process.env.REACT_APP_FLAG_REDIRECT_URL}`,
    },
    {
      image: image2,
      title: "Global Seed Planning Tool",
      appName: "GSPT",
      appUrl: `${process.env.REACT_APP_GSPT_REDIRECT_URL}`,
    },
    {
      image: image3,
      title: "PFNA Grower's Hub",
      appName: "PFNA",
    },
  ];

  const user = useSelector((state) => state.user);
  const appNameList = [];
  user?.applications?.filter((item) => appNameList.push(item?.appName));
  console.log("application from appNameList", appNameList);

  const appList = cardData?.filter((item) => {
    return appNameList?.includes(item?.appName);
  });
  console.log("application from appNameList", user, appList, appNameList);

  return (
    <Box
      sx={{
        display: "flex",
        padding: "16px",
        flexDirection: "column",
        gap: "24px",
        width: "100%",
        borderRadius: "8px", // Small corner radius
      }}
    >
      <Typography
        sx={{
          color: "#3A3A3A", // Fallback for var(--Tokens-Text-Primary)
          textAlign: "center",
          fontFeatureSettings: "'liga' off, 'clig' off", // Font feature settings
          fontFamily: "Inter, sans-serif", // Fallback for var(--Typography-Font-Family-Heading)
          fontSize: "22px", // Fallback for var(--Font-Size-H5)
          fontStyle: "normal",
          fontWeight: 700, // Bold text
          lineHeight: "32px", // Fallback for var(--Line-Height-H5)
          alignSelf: "stretch", // Align to stretch the full width
        }}
      >
        {/* Your text goes here */}
        Welcome to PepsiCo Agriculture Headquarters
      </Typography>

      {appList?.map((item, index) => {
        return (
          <MobileCards
            key={index}
            title={item.title}
            image={item.image}
            url={item.appUrl}
            appName={item.appName}
          />
        );
      })}
    </Box>
  );
}
